module.exports = __webpack_public_path__ + "static/electrification-appliances-64bd38d14c8109fb9985ccd0fe75f136.webp";